import { type ServerFieldErrors, translateServerFieldErrors } from '@/helper/validation/serverFieldErrors';
import { type FormikErrors, type FormikHelpers, type FormikTouched, setIn } from 'formik';

type ServerErrorFormikHelpers<T> = Pick<FormikHelpers<T>, 'setErrors' | 'setTouched'>;

export async function applyServerFieldErrors<T>(
  fieldErrors: ServerFieldErrors,
  helpers: ServerErrorFormikHelpers<T>,
  translate: (message: string) => string
): Promise<void> {
  const translatedErrors = translateServerFieldErrors(fieldErrors, translate);
  const errors = Object.entries(translatedErrors).reduce(
    (state, [path, message]) => setIn(state, path, message),
    {} as FormikErrors<T>
  );
  const touched = Object.keys(fieldErrors).reduce((state, path) => setIn(state, path, true), {} as FormikTouched<T>);

  helpers.setErrors(errors);
  await helpers.setTouched(touched, false);
}
